import { useLocation } from 'react-router-dom';
import { BreadCrumbs } from '@employ-engage/common-components';
import ReportsPage from '../reports-page/reports-page';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ReportsPageWrapperProps {}

export function ReportsPageWrapper(props: ReportsPageWrapperProps) {
  const { t } = useTranslation(['common']);
  const location = useLocation();
  const breadCrumbPages = location.state?.breadCrumbPages || [];

  return (
    <div>
      <BreadCrumbs
        homePath="/admin"
        pages={[
          ...breadCrumbPages,
          {
            name: t('Reports'),
            to: location.pathname + location.search + location.hash,
          },
        ]}
      />
      <ReportsPage />
    </div>
  );
}

export default ReportsPageWrapper;
